<template>
    <div>
        <a-form id="form-detail-banner" :form="form" class="row" layout="horizontal">
            <a-form-item class="col-md-6">
                <h5>Titulo:</h5>
                <a-input placeholder="Ej. Términos y condiciones" v-model="updateItem.title" ref="title"/>
            </a-form-item>
            <a-form-item class="col-md-6">
                <h5>Slug:</h5>
                <a-input placeholder="terminos-y-condiciones" v-model="updateItem.slug" ref="slug"/>
            </a-form-item>
        </a-form>
        <vue-editor 
            v-if="!load" 
            v-model="textUpdate"
            id="editor"
            use-custom-image-handler
            :customModules="customModulesForEditor"
            :editorOptions="editorSettings"
            @image-added="handleImageAdded"
        ></vue-editor>
        <div class="loader-box" v-if="load">
            <img src="../../../assets/icons/loader.gif" width="32"/>
        </div>

        <p class="error-msn" v-if="errorMsn">
            *{{ errorMsn }}
        </p>

        <div class="box-buttons" v-if="!load">
            <a-button type="primary" v-if="!isNew && !loadSave" class="float-right button" @click="editItem()">Guardar</a-button>
            <a-button type="primary" v-if="isNew && !loadSave" class="float-right button" @click="createItem()">Crear</a-button>
            <a-button type="danger" v-if="isNew && !loadSave" class="float-right button" @click="close()">Cancelar</a-button>
            <img v-if="loadSave" src="../../../assets/icons/loader.gif" width="32"/>
            <a-button type="danger" v-if="!isNew" class="float-right button" @click="deleteItemById(updateItem.id, updateItem.objectID)">Eliminar</a-button>
        </div>
    </div>
</template>

<script>
// basic import
import { VueEditor, Quill } from "vue2-editor";
import { ImageDrop } from 'quill-image-drop-module'
import {ImageResize} from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)


const algoliasearch = require('algoliasearch');
import axios from 'axios';
import { countryConfig } from "../../../country-config/country-config";
import firebase from 'firebase/app';

const firebaseConfigPoliticas = {
  apiKey: "AIzaSyAMyfwKnQVrDuDipz4QDY2i8qzSrX9huVw",
  authDomain: "politicas-col.firebaseapp.com",
  projectId: "politicas-col",
  storageBucket: "politicas-col.appspot.com",
  messagingSenderId: "963364882064",
  appId: "1:963364882064:web:4498d483a33c0b12c07a15"
}; 
var secondary = firebase.initializeApp(firebaseConfigPoliticas, "secondary");
//!firebase.apps.length ? firebase.initializeApp(firebaseConfigPoliticas) : firebase.app();

const client = algoliasearch(countryConfig.algoliaConf.envs.prod.id, countryConfig.algoliaConf.envs.prod.key);
const index = client.initIndex(countryConfig.algoliaConf.envs.prod.properties);

export default {
    name: 'ItemTermsDetail',
    props: ['content', 'terms', 'id', 'currentItem', 'isNew'],
    emits: ['update:textUpdate'],
    data() {
        return {
            form: this.$form.createForm(this, { name: 'termsForm' }),
            newTerms: [],
            textUpdate: "",
            load: false,
            loadSave: false,
            errorMsn: null,
            customModulesForEditor: [
                { alias: "imageDrop", module: ImageDrop },
                { alias: "imageResize", module: ImageResize }
            ],
            editorSettings: {
                modules: {
                    imageDrop: true,
                    imageResize: {
                        handleStyles: {
                            backgroundColor: 'black',
                            border: 'none',
                            borderRadius: '6px'
                            // other camelCase styles for resize handles
                        },
                        displaySize: true,
                        modules: ["Resize", "DisplaySize", "Toolbar"],
                        displayStyles: {
                            backgroundColor: 'black',
                            border: 'none',
                            //color: white
                            // other camelCase styles for size display
                        }
                    }
                },
                theme: 'snow'
            }
        };
    },
    created() {
        if(!this.isNew){
            this.getTerm();
        }
    },
    components: {
        VueEditor
    },
    methods: {
        entitiesHtml(string) {
            return String(string).replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        },
        refreshTermsList() {
            console.log('Editar', this.updateItem.objectID)
            axios.put(
                `${countryConfig.utilities}${countryConfig.redisClear}`,
                {
                    objectIds: ['TERMS_CMS_COL_LIST', `${this.updateItem.objectID}` ]
                },
                {
                    headers: {
                        'country': "COL"
                    },
                }
            ).then(({ data }) => {
                //console.log('Terms', data.terms)
                return this.itemsTerms = data.terms;
            }).catch(err => {
                //console.log(err);
            })
        },
        close() {
            this.$emit('closeDetail', true);
            this.form.resetFields();
        },
        deleteItemById(id, objectID){
            this.newTerms = this.terms.filter( item => item.id !== id );
            const data = [
                {
                    termsList: this.newTerms,
                    objectID: "TERMS_CMS_COL_LIST"
                }   
            ]

            index.deleteObject( objectID ).then();

            index.partialUpdateObjects(data).then(({ objectIDs }) => {
                this.refreshTermsList();
                this.updateTermsFunc(this.newTerms)
            });

            this.close();
        },
        updateTermsFunc(terms){
            this.$emit('updateTerms', terms);
        },
        getTerm() {
            console.log('Get Terms', this.updateItem.objectID)
            axios.get(
                countryConfig.properties,
                {
                headers: {
                    'country': "COL"
                },
                params: {
                    objectID: this.updateItem.objectID
                }
                }
            )
            .then(({ data }) => {
                this.textUpdate = decodeURIComponent(escape(window.atob(data.textEdit)));
                this.load = true;
            }).catch(err => {
                console.log(err);
            }).finally(()=>{
                this.load = false;
            });
        },
        editItem(){
            this.newTerms = this.terms;

            const data = [
                {
                    termsList: this.newTerms,
                    objectID: "TERMS_CMS_COL_LIST"
                },
                {
                    textEdit: btoa(unescape(encodeURIComponent( this.textUpdate ))),
                    objectID: this.updateItem.objectID
                }
            ];

            index.partialUpdateObjects(data)
            .then(() => {
                this.loadSave = true;
                this.errorMsn = '';
                this.refreshTermsList()
            })
            .catch((err)=>{
                console.log(err.statusCode)
                if( err.statusCode === 400 ){
                    return this.errorMsn = 'El tamaño del texto es demasiado grande';
                }                
            })
            .finally(()=>{
                this.loadSave = false;
                if( !this.errorMsn ){
                    this.close();
                }
            })
        },
        createItem(){
            const idNew = Date.now();
            
            const newItem = {
                id: idNew,
                //text: btoa(unescape(encodeURIComponent( this.value ))),
                slug: this.updateItem.slug,
                title: this.updateItem.title,
                objectID: `TERMS_CMS_${idNew}`
            }

            this.newTerms = this.terms;
            this.newTerms.push( newItem );

            const data = [
                {
                    termsList: this.newTerms,
                    objectID: "TERMS_CMS_COL_LIST"
                },
                {
                    textEdit: btoa(unescape(encodeURIComponent( this.textUpdate ))),
                    objectID: `TERMS_CMS_${idNew}`
                }
            ];

            index.partialUpdateObjects(data)
            .then(( objectIDs ) => {
                console.log('Creado nuevo', objectIDs)
                this.refreshTermsList();
            })
            .catch((err)=>{
                console.log(err.statusCode)
                if( err.statusCode === 400 ){
                    return this.errorMsn = 'El tamaño del texto es demasiado grande';
                }                
            })
            .finally(()=>{
                this.loadSave = false;
                if( !this.errorMsn ){
                    this.close();
                }
            })
        },
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
            var formData = new FormData();
            formData.append("image", file);
            
            if( file.size <= 11500000 /* 1500000 */ ){
                secondary
                    .storage()
                    .ref(`${file.name}`)
                    .put(file).then( res=>{
                        res.ref.getDownloadURL().then( url =>{
                            console.log('Subida de archivos: ', url )
                            Editor.insertEmbed(cursorLocation, "image", url);
                            resetUploader();
                        })
                        .catch(err => {
                            console.log(err);
                        });
                    })
            }else{
                console.log( 'El archivo supera 1MB de peso' )
            }
        }
    },
    computed: {
        updateItem: {
            get() {
                console.log('this.currentItem: ', this.currentItem)
                if(this.currentItem){
                    return this.currentItem
                }else{
                    return {
                        title: "",
                        slug: "",
                        objectID: ""
                    }
                }
            },
            set(updateItem) {
                this.$emit('update:currentItem', updateItem )
            }
        },
        updateId: {
            get() {
                return this.id
            },
            set(updateId) {
                console.log( 'id', this.id )
                this.$emit('update:id', updateId )
            }
        }
    },
    watch: {
        updateTerms: function () {
            this.$emit('updateTerms', true);
        },
        textUpdate: function (newValue, oldValue) {
            //console.log(newValue, oldValue)
        },
        id: function (newValue, oldValue) {
            this.load = true;
            this.getTerm();
        },
        currentItem: function (newValue) {
            if(newValue.id === undefined && this.isNew){
                //console.log('Nuevo')
                this.load = false;
                this.textUpdate = '';
            }
        },
        load: function (newValue, oldValue) {
            //console.log(newValue, oldValue)
        }
    }
}
</script>

<style>
.button{
  margin: 0 .5rem;;
}

.loader-box{
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.box-buttons{
    padding: 2rem 0;
}

.error-msn{
    color: #a54545;
    text-align: left;
    font-weight: 500;
    margin: 0.5rem 0;
}
</style>